import { CROSS_REGION_ALLOWED_CROSS_ORIGIN } from "../cross-region/getter-types";
import {
  ROUTE_PARAMS_CLUSTER_NAME,
  ROUTE_PARAMS_DOMAIN,
} from "../route/getter-types";
import { ACTIVE_STATUS_ON_CHANGE } from "./action-types";
import { getHrefFromCluster } from "./helpers";

const actions = {
  [ACTIVE_STATUS_ON_CHANGE]: ({ getters }, cluster) => {
    const allowedCrossOrigin = getters[CROSS_REGION_ALLOWED_CROSS_ORIGIN];
    const clusterName = getters[ROUTE_PARAMS_CLUSTER_NAME];
    const domainName = getters[ROUTE_PARAMS_DOMAIN];
    const { origin, pathname } = window.location;

    const href = getHrefFromCluster({
      allowedCrossOrigin,
      cluster,
      clusterName,
      domainName,
      origin,
      pathname,
    });

    window.location = href;
  },
};

export default actions;
